import { useParams } from "react-router-dom";
import { useAuth } from "@/api/auth/AuthProvider";

export const useWorkspaceId = () => {
  const { workspaceId } = useParams();
  const { defaultWorkspaceId } = useAuth();

  return {
    workspaceId: workspaceId ? workspaceId : defaultWorkspaceId,
  };
};

export default useWorkspaceId;
